import { DestroyRef, inject } from '@angular/core';
import { BaseItemService } from '@core/frontend-shared';
import { ModelFactoryProvider } from '@core/shared/model';
import { ConfirmDialogService } from '@common/ui/frontend-shared/confirmdialog';
import { ItemController2 } from './item.controller2';
import * as i0 from "@angular/core";
import * as i1 from "@common/ui/frontend-shared/confirmdialog";
import * as i2 from "@core/shared/model";
export let CrudControllerFactory = /*#__PURE__*/(() => {
  class CrudControllerFactory {
    constructor(confirmationService, modelFactoryProvider) {
      this.confirmationService = confirmationService;
      this.modelFactoryProvider = modelFactoryProvider;
      this.destroyRef = inject(DestroyRef);
    }
    createItemController(service, restraints) {
      if (arguments.length === 1) {
        restraints = service.restraints;
        service = service.service;
      }
      const controller = new ItemController2(this.confirmationService, this.modelFactoryProvider);
      controller.initialize(service, restraints);
      return controller;
    }
    static {
      this.ɵfac = function CrudControllerFactory_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CrudControllerFactory)(i0.ɵɵinject(i1.ConfirmDialogService), i0.ɵɵinject(i2.ModelFactoryProvider));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: CrudControllerFactory,
        factory: CrudControllerFactory.ɵfac
      });
    }
  }
  return CrudControllerFactory;
})();